module.exports = __webpack_public_path__ + "img/logo1.b6c1046d.png";